import React, { FC } from "react";
import { NewNavInterface } from "containers/common/sections/layout/NewNav/NewNav";
import { DarkLogo } from "assets/svgs/nav";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import NavLinkDropdownDesktop from "containers/common/sections/layout/NewNav/NavLinkDropdownDesktop";
import { PageLink } from "components/common/atoms";
import NavLangs from "evcharging/components/navigation/NavLangs";
import useI18n from "evcharging/hooks/useI18n";
import { dropdownOptions } from "evcharging/providers/ServicesProvider";

const DesktopMenu: FC<NewNavInterface> = () => {
  const theme = useTheme();
  const classes = createStyles(theme);
  const { t } = useI18n();

  return (
    <>
      <div className={classes.topNav}>
        <div className={classes.container}>
          <div>
            <PageLink href="/" aria-label={t('nav.home')}>
              <DarkLogo />
            </PageLink>
          </div>
          <span>
            <PageLink aria-label={"Home"} href="/">
              {t('nav.home')}
            </PageLink>
          </span>
          <span>
            <PageLink href="/about-us" aria-label={t('nav.about')}>
              {t('nav.about')}
            </PageLink>
          </span>
          <span>
            <NavLinkDropdownDesktop
              links={dropdownOptions}
              label={t('nav.services')}
              title={''}
            />
          </span>
          {/*<span>
            <PageLink href="/blog" aria-label={t('nav.blog')}>
              {t('nav.blog')}
            </PageLink>
          </span>*/}
          {/*<span>
            <PageLink href="/our-providers" aria-label={t('nav.providers')}>
              {t('nav.providers')}
            </PageLink>
          </span>*/}
          <span>
            <PageLink href="/faq" aria-label={t('nav.faq')}>
              {t('nav.faq')}
            </PageLink>
          </span>
          <PageLink href={'/contact-us'} aria-label={t('nav.contact')} className={classes.contactLink}>
            {t('nav.contact')}
          </PageLink>
          <NavLangs />
        </div>
      </div>
    </>
  );
};

const createStyles = (theme: Theme) => ({
  topNav: css({
    zIndex: 99999,
    position: "fixed",
    top: 0,
    width: "100%",
    height: 98,
    backgroundColor: "#333",
    boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
    fontSize: 14,
    fontWeight: 600,
    color: theme.colors.accent,
    transition: "background-color .3s"
  }),
  container: css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 12px",
    "& > div:first-child": {
      marginRight: "auto"
    },
    "& > span": {
      paddingRight: theme.spacing(6),
      [theme.breakpoints.mobile.up]: {
        fontSize: 18
      },
      color: "#fff",
      willChange: "color",
      transition: "color 0.2s ease",
      "&:hover": {
        color: theme.colors.accent
      }
    }
  }),
  contactLink: css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 150,
    padding: "10px 0",
    background: "#F9C106",
    borderRadius: 6,
    color: "#333",
    fontSize: 18,
    fontWeight: 600
  }),
  catalogLink: css({
    padding: "10px 25px",
    border: "1px solid #FFFFFF",
    borderRadius: 6
  })
});

export default DesktopMenu;
